import { DomainCode } from '@australiangreens/ag-internal-components';
import { assembleHydratedQuickFilter } from './assembleHydratedQuickFilter';
import { FilterCriteria, filterInitialState } from './filterCriteriaReducer';
import { HydrateQuickFilterResult } from './hydrateQuickFilterCriteriaTypes';
import { loadQuickFilterRelatedData } from './loadQuickFilterRelatedData';
import { defaultAccordionStates } from './quickFilterLoaderConstants';

export type { HydrateQuickFilterResult } from './hydrateQuickFilterCriteriaTypes';

export async function hydrateQuickFilterCriteria({
  filter,
  searchId,
  token,
  domainCode,
  userSub,
}: {
  filter: FilterCriteria | null;
  searchId: number | undefined;
  token: string;
  domainCode: DomainCode;
  userSub: string;
}): Promise<HydrateQuickFilterResult | null> {
  if (!searchId) {
    return {
      filterCriteria: filterInitialState,
      accordionStates: defaultAccordionStates,
      missingFilters: [],
    };
  }

  if (!filter) {
    return null;
  }

  const related = await loadQuickFilterRelatedData({ filter, token, domainCode, userSub });
  return assembleHydratedQuickFilter({ filter, related });
}
